import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const productionRoutes: RouteRecordRaw[] = [
    {
        name: 'production-navigation',
        path: '/production/navigation',
        component: () => import('@/views/production/ProductionNavigation.vue'),
        beforeEnter: () => haveOneAccess([
            permissionList.READ_PRODUCTION,
            permissionList.CREATE_PRODUCTION
        ]) ? true : { name: 'dashboard' },
    },
    {
        name: 'production',
        path: '/production/',
        component: () => import('@/views/production/ProductionIndex.vue'),
        beforeEnter: () => canAccess(permissionList.READ_PRODUCTION) ? true : { name: 'production-navigation' },
    },
    {
        name: 'production-detail',
        path: '/production/:id(\\d+)',
        component: () => import('@/views/production/DetailProduction.vue'),
        beforeEnter: () => canAccess(permissionList.READ_PRODUCTION) ? true : { name: 'production-navigation' },
    },
    {
        name: 'production-new',
        path: '/production/new',
        component: () => import('@/views/production/NewProduction.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_PRODUCTION) ? true : { name: 'production-navigation' },
    },
    {
        name: 'production-update',
        path: '/production/update/:id(\\d+)',
        component: () => import('@/views/production/UpdateProduction.vue'),
        beforeEnter: () => canAccess(permissionList.UPDATE_PRODUCTION) ? true : { name: 'production-navigation' },
    },
]

export default productionRoutes
